/* global angular */

angular.module('services.comments', ['gc.services', 'gc.user', 'gc.lang'])
.service('CommentService', [
'$http',
'$log',
'$rootScope',
'$timeout',
'$filter',
'$q',
'getSearchParameters',
'Utils',
'LocalStorageService',
'ReadStatusService',
'API_URL',
'URL_SHORTENER',
'DEFAULT_LANGUAGE',
'APP_LANGUAGES',
'PostMessageService',
'$injector',
function ($http, $log, $rootScope, $timeout, $filter, $q, getSearchParameters, Utils, LocalStorageService,
          ReadStatusService, API_URL, URL_SHORTENER, DEFAULT_LANGUAGE, APP_LANGUAGES, PostMessageService, $injector) {
  'use strict';
  var service = this;
  var readyEventDispatched = false;

  this.lastVisit = LocalStorageService.getItem('last_visit_' + Utils.getUniqueUrlIdentifier());
  var threshold = moment().subtract(1, 'hour');
  if (!this.lastVisit || moment(this.lastVisit).isBefore(threshold)) {
    LocalStorageService.setItem('last_visit_' + Utils.getUniqueUrlIdentifier(), new Date().toISOString());
  }

  function api_error(err) {
    $log.error('CommentService', err);
  }

  /**
   * @internal flatten a tree of comments
   * @param  {Object} memo the hash containing all the comments indexed by id
   * @param  {Object} node An comment object or a hash
   * @return {Object} The hash containing references to comments
   */
  function _flattenComments(memo, node) {
    if (node._id) {
      memo[node._id] = node;
    } else {
      memo[node] = node;
    }

    if (node.child_comments && angular.isArray(node.child_comments)) {
      node.child_comments.reduce(_flattenComments, memo);
    }

    return memo;
  }

  function checkIsNew(comment, clicked_id) {
    comment.child_comments.forEach(function (child_comment) {
      if (service.isMine(child_comment)) return;

      child_comment.is_read = ReadStatusService.isRead(child_comment._id);

      child_comment.is_new = (
        !service._comments[child_comment._id] && (
          service._comments[comment._id] &&
          service._comments[comment._id].child_comments_ids.indexOf(child_comment._id) === -1
        )
      ) || (
        !child_comment.is_read &&
        !service.isMine(child_comment) &&
        service.isAfterLastVisit(child_comment)
      );

      // indicate there's new replies all the way to the top comment
      if (child_comment.is_new) {
        var cmt = child_comment;
        while (cmt.parent_id) {
          cmt = service._comments[cmt.parent_id];

          // sometimes at initial page load, we can have a children already stored,
          // but not it's parent, we can safely ignore it
          if (!cmt) return;

          cmt.has_new_replies = true;
        }
      }
    });

    if (comment._id === clicked_id) merge(comment);

    comment.child_comments.forEach(function (child_comment) {
      checkIsNew(child_comment);
    });
  }

  function merge(comment) {
    if (service._comments[comment._id]) {
      // we want to keep (object) references to all children,
      // so we replace all children returned by the API with the one we already have
      comment.child_comments.forEach(function(c, index) {
        if (service._comments[c._id]) {
          comment.child_comments[index] = service._comments[c._id];
        }
      });

      angular.extend(service._comments[comment._id], comment);
    } else {
      service._comments[comment._id] = comment;
    }
  }

  function computeVotes(comment) {
    comment.top_voters = Utils.topVoters(comment, true);
    comment.votes_count = Utils.votesCount(comment, true);
  }
  service.computeVotes = computeVotes;

  // same as _flattenComments
  function updateComments(comment, recursive) {
    computeVotes(comment);
    if (!comment.count_child) comment.count_child = 0;
    comment.child_comments.forEach(function (child_comment) {
      merge(child_comment);
      recursive && updateComments(child_comment, true);
    });

    // we always update children first, then the comment
    // like that we keep (object) reference to all children
    merge(comment);
  }

  // The hashtable
  this._comments = {};
  this.comments = [];
  this.ecd = [];
  this.thread_id = '';
  this.website_id = '';
  this.url = '';
  this.website = '';

  function retrieveComment(cmt_id) {
    for (var key in service._comments) {
      if (service._comments[key]._id === cmt_id) {
        return service._comments[key];
      }
    }
    return false;
  }

  service.retrieveComment = retrieveComment;

  function getUserInfos() {
    var GcUser = $injector.get('GcUser');
    var guest = GcUser.getGuest();
    var user = GcUser.getUser();

    if (guest) {
      return {
        email: guest.email,
        username: guest.username,
      };
    } else if (user) {
      return {
        _id: user._id,
        depth: user.loading_depth === -1 ? null : user.loading_depth + 2,
      };
    }
  }

  function unfold(currentDepth, node) {
    // we stop to depth 1 to remain the last comment in a bubble
    if (currentDepth === 0) return;

    node.active = true;

    if (!node.child_comments || node.child_comments.length === 0) return;

    unfold(currentDepth - 1, node.child_comments[0]);
  }

  function getLoadingDepth() {
    var loadingDepth = (service.website.loading_depth || DEFAULT_DEPTH) - 1;
    var user = $injector.get('GcUser').getUser();
    if (user && typeof user.loading_depth !== 'undefined' && user.loading_depth !== -1) {
      loadingDepth = user.loading_depth + 1;
    }
    return loadingDepth;
  }

  function displaySearch(comment,value){
      
      var content = comment.content.replaceAll(value, `<span class="gc-selected-search-word">${value}</span>`);
      comment.content = content;
      comment.isSearch = true;
      return comment;
  }

  this.updateCachedUser = function (id, objValues) {

    var GcUser = $injector.get('GcUser');
    GcUser.updateKnownUserField(id, objValues);

    var cachedUser = {
      username: objValues.username,
      picture: objValues.picture
    };

    // To update the browser cache for the picture
    if (cachedUser.picture !== undefined) {
      cachedUser.picture += '#' + (Math.floor(Math.random() * 1000 + 1));
    }

    function modifyCommentsListCachedUser(author_id, new_objValues, c) {
      c.forEach(function (com) {
        if (com && com.author && com.author._id === author_id) {
          angular.extend(com.cached_author, new_objValues);
        }
        modifyCommentsListCachedUser(id, new_objValues, com.child_comments);
      });
    }

    modifyCommentsListCachedUser(id, cachedUser, this.comments);
  };

  this.getWebsite = function (websiteId) {
    return $http.get(API_URL + '/pub/website/' + websiteId).success(function(website) {
      service.website = website;
      $rootScope.website = website;
      $rootScope.sso_direct_link = null;
      $rootScope.isOrange = website.custom_client === 'orange';
      $log.debug('website', website);
     // console.log('$rootScope.website',  $rootScope.website)
      // uncomment to debug
      //service.website.disable_user_page = true;
      //service.website.guest = false;
      //service.website.cgu = { input_front_active: true, input_front_txt: '<a href="http://google.fr">google</a>' };
      //service.website.ads = {"header":{"active":true,"content":"<script>\n(function(){\nvar s=document.createElement('script');\ns.src='//ads.sportslocalmedia.com/slm.prebid.lephoceen.js?'+((new Date).getTime()/1e3/600).toFixed();\ns.type='text/javascript';s.async='true';\ntry{ var i=document.getElementsByTagName('script')[0];i.parentNode.insertBefore(s,i); }catch(e){};\n})();\n</script>"},"responsive":{"active":true,"content":"<div id='Lephoceen_Native_{{adIndex}}'></div>\n<script type='application/javascript'>\nvar slmadshb = window.slmadshb || {};\nslmadshb.que = slmadshb.que || [];\nfunction NbPair(Nb)\n{\nif(Nb/2 == Math.round(Nb/2)) return true;\nelse return false;\n}\nslmadshb.que.push(function() {\nif(1 == {{adIndex}})\n{\nslmadshb.display({code: 'Lephoceen_ATF_300x250', id: 'Lephoceen_Native_{{adIndex}}'});\n}\nelse if(2 == {{adIndex}}) {\nslmadshb.display({code: 'Lephoceen_BTF_300x250', id: 'Lephoceen_Native_{{adIndex}}'});\n}\nelse {\nif(NbPair({{adIndex}}) === true) {\nslmadshb.display({code: 'Lephoceen_BTF_300x250', id: 'Lephoceen_Native_{{adIndex}}'});\n}\nelse {\nslmadshb.display({code: 'Lephoceen_Native', id: 'Lephoceen_Native_{{adIndex}}'});\n}\n}\n});\n</script>"},"mobile":{"active":true,"content":"<div id='Lephoceen_Native_{{adIndex}}'></div>\n<script type='application/javascript'>\nvar slmadshb = window.slmadshb || {};\nslmadshb.que = slmadshb.que || [];\nfunction NbPair(Nb)\n{\nif(Nb/2 == Math.round(Nb/2)) return true;\nelse return false;\n}\nslmadshb.que.push(function() {\nif(1 == {{adIndex}})\n{\nslmadshb.display({code: 'Lephoceen_ATF_300x250', id: 'Lephoceen_Native_{{adIndex}}'});\n}\nelse if(2 == {{adIndex}}) {\nslmadshb.display({code: 'Lephoceen_BTF_300x250', id: 'Lephoceen_Native_{{adIndex}}'});\n}\nelse {\nif(NbPair({{adIndex}}) === true) {\nslmadshb.display({code: 'Lephoceen_BTF_300x250', id: 'Lephoceen_Native_{{adIndex}}'});\n}\nelse {\nslmadshb.display({code: 'Lephoceen_Native', id: 'Lephoceen_Native_{{adIndex}}'});\n}\n}\n});\n</script>"}};
      service.website.searchActive = false;
      if(website.graphcomment && website.graphcomment.search_motor){
        service.website.searchActive = website.graphcomment.search_motor.active;
      }

      if (website.count_per_page === Number.MAX_VALUE) {
        website.count_per_page = Number.POSITIVE_INFINITY;
      }

      if(website.first_load_count === Number.MAX_VALUE) {
        website.first_load_count = Number.POSITIVE_INFINITY;
      }

      if(website.sso && website.sso.active && website.sso.login_redirect && !website.sso.unidirectional) {
        var ssoUrl = website.sso.link;
        if (Utils.inApp()) {
          $rootScope.sso_direct_link = Utils.appendGetParam(ssoUrl, 'gc_url=' + encodeURIComponent(window.location.href));
        }else{
          $rootScope.sso_direct_link = Utils.appendGetParam(ssoUrl, 'gc_url=' + encodeURIComponent(Utils.getParameterByName('url') || window.location.href));
        }
      }

      if (!website.languages) {
        website.languages = APP_LANGUAGES.map(lang => lang.value);
      }

      if (!service.website.edition) {
        website.edition = {
          link: true,
          upload: true,
          formatting: true,
          emoticons: true,
        };
      }

      if (!website.theme) website.theme = 'auto';

      // set default values for embed limits
      if (typeof website.embeded_files === 'undefined') {
        website.embeded_files= 1;
      }
      if (typeof website.embeded_external_link === 'undefined') {
        website.embeded_external_link = 1;
      }

      $rootScope.$broadcast('website', website);
    });
  };

  this.init = function (params) {
    // To replace later
    var parent_url = window.location.origin + window.location.pathname;

    var qs = getSearchParameters();

    this.page = 0;
    this.title = decodeURIComponent(qs.title) || 'gcmt';
    this.url = decodeURIComponent(qs.url) || parent_url;
    this.identifier = decodeURIComponent(qs.identifier) || 'main';
    this.uid = decodeURIComponent(qs.uid);
    this.guid = decodeURIComponent(qs.guid);
    this.category = decodeURIComponent(qs.category);
    this.publication_date = decodeURIComponent(qs.publication_date);
    this.lifetime = decodeURIComponent(qs.lifetime);
    this.website_id = qs.website_id || 'dev-site-graphcomment';
    this.ecd = [];

    service.commentsAdded = 0;
    params.force_sort = false;

    return this.getThread(params);
  };

  /**
   * Show all threads
   */
  this.getThread = function (params) {
    params = params || {};

    var DEFAULT_DEPTH = 2;
    var user = $injector.get('GcUser').getUser();

    // `force_sort` is true by default
    params.force_sort = typeof params.force_sort === 'undefined' ? true : params.force_sort;

    if (params.comment_id) {
      // don't send this param for a yakli
      delete params.offset;
    }

    // cancel any previous pending request
    if (this.currentThreadRequest) this.currentThreadRequest.resolve();
    this.currentThreadRequest = $q.defer();

    var req = {
      url: API_URL + '/thread?sort=' + $rootScope.sorting + (params.force_sort ? '&force_sort=true' : ''),
      method: 'POST',
      timeout: this.currentThreadRequest.promise,
      data: {
        website_id: this.website_id,
        url: this.url,
        uid: this.uid,
        guid: this.guid,
        category: this.category,
        publication_date: this.publication_date,
        lifetime: this.lifetime,
        identifier: this.identifier,
        page_title: this.title,
        loading_depth: (params.bbf3d === true) ? 3 : this.website.loading_depth,
        parent_id: params.parent_id,
        offset: params.offset,
        limit: params.limit,
        user: getUserInfos(),
        comment_id: params.comment_id, // for yakli
      }
    };

    service.offset = params.offset;
    service.limit = params.limit;

    return $http(req)
      .success(function (thread) {
        // only update children of actual comments in that case
        if (params.parent_id) {
          var fetchedComment = thread.child_comments[0];
          var comment = service.comments.find(c => c._id === fetchedComment._id);
          // update child comments
          comment.child_comments = fetchedComment.child_comments;

          // update everything
          updateComments(comment, true);

          return;
        }

        var hasNewComments;
        if (service.comments.length) {

          thread.child_comments.forEach(comment => {
            if (!service.comments.find(c => c._id === comment._id)) hasNewComments = true;
          });
        }

        if (!service.comments.length || hasNewComments) service.page++;
        service.ecd = thread.ecd;
        service.thread = thread;
        service.thread_id = thread._id;
        service.isLocked = thread.is_locked;
        service.total_comments = thread.count_comments;
        ReadStatusService.setThreadId(service.thread_id);

        $rootScope.$broadcast('thread', thread);

        thread.child_comments.forEach(function (child_comment) {
          if (!params.comment_id) unfold(getLoadingDepth(), child_comment);
          checkIsNew(child_comment);
          updateComments(child_comment, true);
        });


        return service.getPopulate(thread.child_comments);
      })
      .error(function (err) {
        if (err && err.type && err.type === '404') {
          $log.error('The website id ' + opts.website_id + ' has not been created yet');
        }
        else if (err) $log.error(err);

        if (service.website.custom_client === 'orange') {
          $rootScope.spupLog('[spup] thread error: ' + JSON.stringify(err));
        }
      });
  };

  this.getPopulate = function (comments) {

      //service.total_comments = stats;
      comments = comments || service.comments;
      // In case we're on a yakli and we load previous comments.
      // In that case requested offset will always be inferior to current yakli position.
      // And so we know we need to prepend these new comments.
      var prepend = $rootScope.yakli && $rootScope.yakli.pos > service.offset;

      comments.forEach(function(comment, index) {
        if (!service.comments.find(c => c._id === comment._id)) {
          service.comments.splice(index + (prepend ? 0 : service.offset) + service.commentsAdded, 0, comment);
        }
      });

      $rootScope.gcReady = true;

      // dispatch event only once
      if (!readyEventDispatched) {
        $rootScope.$broadcast('gc:ready');
        readyEventDispatched = true;
      }

      $rootScope.$broadcast('thread-stats');
  };

  this.getSearch = function(value){
   var defaultParams = {
      page:1,
      limit:10
   }
   var params = Object.assign(defaultParams, value);
    return $http({
      url: API_URL + '/thread/' + service.thread_id  + '/search/comments/' ,
      method: 'GET',
      params : params
    }).success(function(thread) {
        service.search_comments = [];

        thread.comments.forEach(comment => {
          service.search_comments.push(displaySearch(comment, params.search));
        });
    });
  }

  this.countComments = function() {
    var qs = getSearchParameters();
    if (!qs.website_id) return { success: () => {} };
    var url = API_URL + '/pub/numberOfComments?website=' + qs.website_id;
    url += '&url=' + encodeURIComponent(qs.url);
    if (qs.uid) url += '&uid=' + encodeURIComponent(qs.uid);
    if (qs.guid) url += '&guid=' + encodeURIComponent(qs.guid);

    return $http.get(url);
  };

  this.reset = function() {
    service.page = 0;
  };

  this.waitForWebsite = function(cb) {

    if (service.website) {
      cb(service.website);
      $rootScope.spupLog('[spup] has website', !!service.website);
    }
    else {
      $rootScope.$on('website', function(e, website) {
        $rootScope.spupLog('[spup] website fetched', !!website);
        cb(website);
      });
    }
  };

  this.waitForThread = function(cb) {
    if (service.thread) cb(service.thread);
    else {
      $rootScope.$on('thread', function(e, thread) {
        cb(thread);
      });
    }
  };

  this.resetAll = function() {
    service.page = 0;
    service.comments = [];
    service._comments = {};
  };

  this.getCustomImage = function() {
    if (service.website && service.website.plan && service.website.custom && service.website.custom.image) {
      return service.website.custom.image;
    }
  };

  this.initDataVote = function (connectedUser) {

    function handleCommentList(commentsList) {

      for (var key in commentsList) {
        commentsList[key].rating = {
          has_voted: false,
          vote_rate: 0
        };
        if (connectedUser !== undefined && connectedUser !== null) {
          if (!commentsList[key].author || commentsList[key].author._id !== connectedUser._id) {
            var found = $filter('filter')(commentsList[key].voters, { user: connectedUser._id.toString() });
            if (found !== undefined && found.length > 0) {
              // The user has already voted
              commentsList[key].rating.has_voted = true;
              commentsList[key].rating.vote_rate = found[0].score;
            }
          }
        }
        if (commentsList[key].child_comments && commentsList[key].child_comments.length > 0) {
          handleCommentList(commentsList[key].child_comments);
        }
      }
    }

    function handleCommentObjectList(commentsList) {
      commentsList.forEach(function (comment) {
        comment.rating = {
          has_voted: false,
          vote_rate: 0
        };
        if (connectedUser !== undefined && connectedUser !== null) {
          if (!comment.author || comment.author._id !== connectedUser._id) {
            var found = $filter('filter')(comment.voters, { user: connectedUser._id.toString() });
            if (found !== undefined && found.length > 0) {
              // The user has already voted
              comment.rating.has_voted = true;
              comment.rating.vote_rate = found[0].score;
            }
          }
        }
        if (comment.child_comments && comment.child_comments.length > 0) {
          handleCommentList(comment.child_comments);
        }
      });
    }
    if($rootScope.searchMode) return;
    handleCommentList(this._comments);
    handleCommentObjectList(this.comments);
  };

  this.hasAlreadyVoted = function (comment, user) {
    if (!comment || !user) {
      return false;
    }

    return comment.voters.some(function (vote) {
      return vote.user.toString() === user._id.toString();
    });
  };


  function formatContentForServer(content) {
    // preserve carriage return (replace by <br/>)
    content = content.replace(/\\n/g, ' <br/>');

    // remove ending line breaks
    content = content.replace(/(<br\s?\/?>)+$/g, '');

    // fix first line break ignored by content-editable
    // https://stackoverflow.com/a/11814305/505836
    content = content.replace(/<div>/gi,'<br>').replace(/<\/div>/gi,'');

    // only keep the `src` attribute of all images
    // content = content.replace(/<a href="(\S+)" target="_blank"( style="([^"]*)")?><img src="(\S+)" ?(alt="")? ?(\/)?><\/a>/gi, '$1');
    // I believe this one is better
    content = content.replace(/<a[^<]+href="(\S+)"[^<]*><img[^<]+src="(\S+)"[^<]*><\/a>/gi, '$1');

    // replace code/pre by ``
    content = content.replace(/<code>(.*)<\/code>/gi, '$1');
    content = content.replace(/<pre>(.*)<\/pre>/gi, '$1');

    // strip graphcomment.com url
    content = content.replace(new RegExp(API_URL + '/file/', 'g'), '');

    return content;
  }

  /**
   * Sends a new comment to the API
   */
  this.addMessage = function (data) {

    var url;

    data.content = formatContentForServer(data.content);
    data.rating = {
      has_voted: false,
      vote_rate: 0
    };

    var GcUser = $injector.get('GcUser');
    var guest = GcUser.getGuest();

    url = API_URL + '/thread/' + this.thread_id + '/' + (guest ? 'guest/' : '') + 'comment/' + (data.parent_id || '')

    if (data.parent_id) {
      mixpanel.track('comment:reply');
    } else {
      mixpanel.track('comment:post');
    }


    return $http.post(url, data)
      .success(function (cmt) {
        // If there is no parent_id, append the message on the root
        if (!data.parent_id) {
          service.comments.unshift(cmt);
        } else {
          // increment
          service._comments[data.parent_id].count_child++;
        }

        service._comments[cmt._id] = cmt;
        PostMessageService.postMessage('gc-new-comment', cmt);
        this.removeSavedComment();
      })
      .error(function(err) {
        api_error(err);
      });
  };

  /**
   * Update a comment
   */
  this.updateMessage = function (data) {
    var url;
    var copy = angular.extend({}, data);

    copy.content = formatContentForServer(copy.content);
    copy.rating = {
      has_voted: false,
      vote_rate: 0
    };

    url = API_URL + '/thread/' + this.thread_id + '/comment/' + data._id;

    mixpanel.track('comment:edit');

    return $http.put(url, copy)
      .success(function (cmt) {
        delete cmt.child_comments;
        angular.extend(data, cmt);
        service._comments[cmt._id] = cmt;
      })
      .error(function(err) {
        api_error(err);
      });
  };

  /**
   * Vote on comment
   */
  this.voteOnComment = function (comment, score, boost) {
    var req = {
      url: API_URL + '/thread/' + this.thread_id + '/comment/vote/' + comment._id,
      method: 'POST',
      data: { score, boost },
    };

    $rootScope.$broadcast('comment:vote');

    return $http(req)
      .error(api_error)
      .then(function (response) {
        if (response.data.err) {
          $log.warn('you have already voted');
        }

        comment.voters = response.data.voters;
        comment.score = response.data.score;
        computeVotes(comment);

        if (response.data.result) {
          comment.result = response.data.result;
        }

        return response.data;
      });
  };

  this.remove = function(cmt, parentCmt) {
    var GcUser = $injector.get('GcUser');
    if (GcUser.getUser() && GcUser.getUser().can_moderate) {
      var req = {
        method: 'POST',
        url: API_URL + '/website/' + this.website._id + '/thread/' + ( cmt.thread._id || this.thread_id ) + '/comment/' + cmt._id + '/deleted',
        data: {
          motif: cmt.motif,
          motif_id: cmt.motif_id
        }
      };
    } else {
      var req = {
        method: 'DELETE',
        url: API_URL + '/comment/' + cmt._id,
      };
    }

    return $http(req).success(function(resp) {
      delete resp.child_comments;
      angular.extend(cmt, resp);

      if (resp.content === 'deleted_by_user') return;

      if (parentCmt) {
        var cmtIndex = parentCmt.child_comments.findIndex(function(c) {
          return c._id === cmt._id;
        });
        parentCmt.child_comments.splice(cmtIndex, 1);
        parentCmt.count_child--;
      }
      else {
        var cmtIndex = service.comments.findIndex(function(c) {
          return c._id === cmt._id;
        });
        service.comments.splice(cmtIndex, 1);
      }
    });
  };

  this.disapprove = function(cmt) {
    return $http.post(
      API_URL + '/website/' + this.website._id + '/thread/' + this.thread_id + '/comment/' + cmt._id + '/disapprove',
      {
        motif: cmt.motif,
        motif_id: cmt.motif_id
      }
    ).success(function(data) {
      cmt.status = data.status;
    });
  };

  this.report = function(cmt, data) {
    return $http({
      method: 'POST',
      url: API_URL + '/thread/' + this.thread_id + '/comment/' + cmt._id + '/offense',
      data,
    });
  };

  this.signalAsSpam = function(cmt, parentCmt) {
    return $http({
      method: 'POST',
      url: API_URL + '/website/' + this.website._id + '/thread/' + this.thread_id + '/comment/' + cmt._id + '/markspam',
    }).success(function() {
      this.remove(cmt, parentCmt);
    }.bind(this));
  };

  this.setSort = function(sort) {
    return $http.put(API_URL + '/thread/' + this.thread_id + '/sort', { sort });
  };

  this.isBan = function(banData) {
    return $http.post(API_URL + '/website/' + this.website._id + '/isban', banData);
  };

  this.ban = function(banData) {
    return $http.post(API_URL + '/website/' + this.website._id + '/ban', banData);
  };

  this.unban = function(banData) {
    return $http.put(API_URL + '/website/' + this.website._id + '/ban', banData);
  };

  this.loadChildrenWithParentId = function (cmt, parent_id, depth) {
    var url = API_URL + '/thread/' + this.thread_id + '/load-comment/' + parent_id + '?sort=' + $rootScope.sorting;
    var data = {
      depth: depth || 2,
      clicked_id: cmt._id,
      user: getUserInfos(),
    };

    var GcUser = $injector.get('GcUser');

    // cancel any previous pending request
    if (this.currentLoadChildrenRequest) this.currentLoadChildrenRequest.resolve();
    this.currentLoadChildrenRequest = $q.defer();

    return $http({
      method: 'POST',
      timeout: this.currentLoadChildrenRequest.promise,
      url,
      data
    }).success(function (data) {

        // check new comments
        checkIsNew(data, cmt._id);

        // update service._comments
        data.child_comments.forEach(function (child_comment) {
          if (child_comment._id !== cmt._id) return;
          updateComments(child_comment, true);
        });

        var parent_cmt = retrieveComment(parent_id);

        function findInList(list, obj_to_find) {
          var found = false;
          list.every(function (obj/*, index*/) {
            if (obj._id === obj_to_find._id) {
              found = obj;
              return false;
            }
            return true;
          });
          return found;
        }

        // Var to save the comments that gonna be overwriten by another tha should have its place (in the classement)
        var saved = [];
        var tmp = false;
        parent_cmt.child_comments.every(function (comment, index) {

          // The message was deleted
          if (findInList(data.child_comments, comment) === false) {
            parent_cmt.child_comments.splice(index, 1);
          }

          // The comment is in the good place, nothing to do
          else if (comment._id === data.child_comments[index]._id) {
            return true;
          }

          else if (saved.length > 0 && ((tmp = findInList(saved, data.child_comments[index])) !== false)) {
            saved.push(comment);
            parent_cmt.child_comments[index] = tmp;
            service._comments[tmp._id] = tmp;
            return true;
          }

          else {
            saved.push(parent_cmt.child_comments[index]);
            // Go through the parent_cmt.child_comments to extend the real comment
            if (parent_cmt.child_comments.every(function (comment2, index2) {
                if (data.child_comments[index]._id === comment2._id) {
                  parent_cmt.child_comments[index] = parent_cmt.child_comments[index2];
                  service._comments[parent_cmt.child_comments[index2]._id] = parent_cmt.child_comments[index2];
                  return false;
                }
                return true;
              }) === true) {
              parent_cmt.child_comments[index] = data.child_comments[index];
              service._comments[data.child_comments[index]._id] = data.child_comments[index];
            }
            return true;
          }

          return true;
        });

        // If some comments was added, we have to add them to by 'continuying' to go througt the var 'data.child_comments'
        for (var i = parent_cmt.child_comments.length; i < data.child_comments.length; i++) {
          if (saved.length > 0 && ((tmp = findInList(saved, data.child_comments[i])) !== false)) {
            // $log.debug('LOOP -> Extract from save: ', data.child_comments[i]);
            // $log.debug('LOOP -> Assign from save: ', tmp);
            parent_cmt.child_comments[i] = tmp;
            service._comments[tmp._id] = tmp;
          }
          else {
            parent_cmt.child_comments[i] = data.child_comments[i];
            service._comments[data.child_comments[i]._id] = data.child_comments[i];
          }
        }
        $log.debug(parent_cmt);
      })
      .error(api_error);
  };

  /*
   ** Return simple user object from its ID
   */
  this.getUserObject = function (user_id) {
    return $http({
      url: API_URL + '/users/show/' + user_id + '?website=' + this.website_id,
      method: 'GET'
    });
  };

  this.getComment = function(commentId) {
    return $http.get(API_URL + '/comment/get/' + commentId);
  };

  this.getLastComments = function(since) {
    return $http.get(API_URL + '/thread/' + this.thread_id + '/last-comments?from_date=' + since.toISOString());
  };

  this.getUserInfos = function(userId) {
    return $http.get(API_URL + '/website/' + this.website._id + '/show/' + userId);
  };

  this.getUserComments = function(userId, page = 1, sort = 'date', limit = 10) {
    return $http({
      url: API_URL + '/users/comments/' + userId + '?' +
        '&website_id=' + this.website._id +
        '&page=' + page +
        '&limit=' + limit +
        (sort === 'date' ? '' : '&' + sort + '=true'),
      method: 'GET'
    }).success(function(comments) {
      comments.forEach(function(cmt) {
        computeVotes(cmt);
      });
    });
  };

  this.getUserCount = function(userId) {
    return $http({
      url: API_URL + '/users/comments/' + userId + '?' +
        '&website_id=' + this.website._id +
        '&count=true',
      method: 'GET'
    }).success(function(comments) {
      comments.forEach(function(cmt) {
        computeVotes(cmt);
      });
    });
  };

  /**
   * Retrieve a comment thread from the root to a given comment
   * @param  {[type]} comment_id [description]
   * @return {[type]}            [description]
   */
  this.populate = function (comment_id) {
    var req = {
      url: API_URL + '/thread/populate/' + comment_id + '?sort=' + $rootScope.sorting,
      method: 'GET'
    };

    return $http(req)
      .success(function (node) {
        service._comments[node._id] = node;
        computeVotes(node);
        service._comments = node.child_comments.reduce(_flattenComments, service._comments);
        var commentIndex = null;

        // update comment stat
        if (service.statsMap.hasOwnProperty(node._id)) {
          node.comments = service.statsMap[node._id].comments;
          node.participants = service.statsMap[node._id].participants;
        }

        // focus the comment
        var cmt = service._comments[comment_id];
        cmt.active = true;

        // focus parents too (all the way to the top comment)
        while (cmt.parent_id) {
          cmt = service._comments[cmt.parent_id];
          cmt.active = true;
        }

        service.comments.some(function (comment, i) {
          if (node._id === comment._id) {
            commentIndex = i;
            return true;
          }
          return false;
        });

        // fixing weird bug when replacing root node
        $rootScope.$broadcast('collapse:anything:else', {
          depth: 0,
          rootId: null
        });

        service.commentsAdded++;
        // by default, when you open the details modal, we add sub comments to main thread
        // When you use search, we don't want to add to main thread
        if($rootScope.searchMode) return;
        if (commentIndex !== null) {
          service.comments[commentIndex] = angular.extend({}, service.comments[commentIndex], node);
        } else {
          service.comments.push(angular.extend({}, node));
        }
      })
      .error(api_error)
      .then(function (response) {
        return response.data;
      });
  };

  /**
   * Count all comments in tree
   */
  this.totalComments = function () {
    var total = 0;
    for (var i = 0; i < this.comments.length; i++) {
      total += this.comments[i].comments || 0;
    }
    return total;
  };


  this.getRootComment = function (id) {
    var currentNode = this._comments[id];
    if(currentNode === undefined) return;
    if (!currentNode.parent_id) return currentNode; // already root comment
    if (!currentNode) console.error('comment %s not found', id);
    while (currentNode.parent_id) {
      var parentId = currentNode.parent_id;
      currentNode = this._comments[parentId];
      if (!currentNode) console.error('comment %s not found (from %s)', parentId, id);
    }
    return currentNode;
  };

  this.recursiveFind = function(cmt, cmtId) {
    return cmt.child_comments.find(c => {
      if (c._id === cmtId) return c;
      return service.recursiveFind(c, cmtId);
    });
  };

  this.getLastChildComment = function(cmt) {
    if (cmt.child_comments.length) return this.getLastChildComment(cmt.child_comments[0]);
    return cmt;
  };

  this.getThreadStats = function (comments) {
    return $http.get(API_URL + '/thread/' + service.thread_id + '/countComments')
      .success(function (stats) {

        // update thread.total_comments with the real count
       /* var totalComments = 0;
        stats.forEach(function(stat) {
          totalComments += stat.comments;
        });*/
        service.total_comments = stats;

        /*service.statsMap = stats.reduce(function (acc, stat) {
          acc[stat.parent_id] = stat;
          return acc;
        }, {});*/

        comments = comments || service.comments;

        comments.forEach(function (comment) {

          // Stats return also deleted / refused / spam comment so
          // we skip unknown comment id
         /* if (!service.statsMap.hasOwnProperty(comment._id)) {
            return;
          }
          // update comment stat
          comment.comments = service.statsMap[comment._id].comments;
          comment.participants = service.statsMap[comment._id].participants;*/
        });

        // In case we're on a yakli and we load previous comments.
        // In that case requested offset will always be inferior to current yakli position.
        // And so we know we need to prepend these new comments.
        var prepend = $rootScope.yakli && $rootScope.yakli.pos > service.offset;

        comments.forEach(function(comment, index) {
          if (!service.comments.find(c => c._id === comment._id)) {
            service.comments.splice(index + (prepend ? 0 : service.offset) + service.commentsAdded, 0, comment);
          }
        });

        $rootScope.gcReady = true;

        // dispatch event only once
        if (!readyEventDispatched) {
          $rootScope.$broadcast('gc:ready');
          readyEventDispatched = true;
        }

        $rootScope.$broadcast('thread-stats');
      });
  };

  this.hasMoreComments = function() {
    if (!this.thread) return false;
    if((this.offset + this.limit) < this.thread.total_root_comments){
      return true;
    }
    return false;
  };

  this.addFile = function (img) {
    var fd = new FormData();
    fd.append('file', img);

    return $http.post(API_URL + '/thread/' + service.thread_id + '/add_file', fd, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    }).error(function (data) {
      throw 'Error uploading your image';
    });
  };

  /**
   * Find number of files hosted on graphcomment.com domain in a comment
   */
  this.getNumberOfHostedFiles = function(content) {
    if (!content) return 0;
    var matches = _.unique(
      content.match(/(?=[\s])?([a-z0-9]{24}\.(?:gif|jpg|jpeg|tiff|png|svg|webp))(?=[\s])?/gi)
    );
    return matches ? matches.length : 0;
  };

  this.pin = function(comment) {
    $http.post(API_URL + '/website/' + this.website._id + '/thread/' + service.thread_id + '/comment/' + comment._id + '/pinned')
      .success(function(resp) {
        comment.pinned = resp.pinned;
      });
  };

  /**
   * Get all selected messages for ECD
   */
  this.getSelectedECD = function () {
    var res = [];

    (function tree(comments) {
      comments.forEach(function (cmt) {
        if (cmt.editor_choice === true) {
          res.push(cmt);
        }
        if (cmt.child_comments && cmt.child_comments.length > 0) {
          tree(cmt.child_comments);
        }
      });
    })(this.comments);

    return res;
  };

  /**
   * Get all selected messages for ECD
   */
  this.cancelSelectedECD = function () {
    (function tree(comments) {
      comments.forEach(function (cmt) {
        if (cmt.editor_choice === true) {
          cmt.editor_choice = false;
        }
        if (cmt.child_comments && cmt.child_comments.length > 0) {
          tree(cmt.child_comments);
        }
      });
    })(this.comments);
  };

  this.isAfterLastVisit = function(comment) {
    return moment(comment.created_at).isAfter(service.lastVisit);
  };

  this.isMine = function(cmt) {
    var GcUser = $injector.get('GcUser');
    var user = GcUser.getUser();
    var guest = GcUser.getGuest();

    if (cmt.author && user && user._id === cmt.author._id) return true;
    if (cmt.cached_author && guest && guest.email === cmt.cached_author.email) return true;

    return false;
  };

  this.append = function(cmt) {
    var parent = service._comments[cmt.parent_id];
    if (!parent) return;

    // if comment is already there, do nothing
    if (parent.child_comments.find(c => c._id === cmt._id)) return;

    cmt.is_new = true;
    merge(cmt);

    // indicate there's new replies all the way to the top comment
    var c = cmt;
    while (c.parent_id) {
      c = service._comments[c.parent_id];
      if (!c) break;
      c.has_new_replies = true;
    }

    // if last comment opened is the parent, we directly open the child
    if ($rootScope.lastCommentOpened === parent._id && !parent.child_comments.length) {
      $rootScope.$emit('comment:' + parent._id + ':setChildComment', cmt);
      $rootScope.lastCommentOpened = cmt._id;
    }

    parent.child_comments.unshift(cmt);
    parent.child_comments_ids.unshift(cmt._id);
  };

  this.setSavedComment = function(content, parent) {
    LocalStorageService.setItem('gc_saved_comment_' + this.thread_id, { content, parent_id: parent && parent._id });
  };

  this.getSavedComment = function() {
    return LocalStorageService.getItem('gc_saved_comment_' + this.thread_id);
  };

  this.removeSavedComment = function(resetWriteArea) {
    LocalStorageService.removeItem('gc_saved_comment_' + this.thread_id);
    if (resetWriteArea) {
      $rootScope.$broadcast('reset_write_comment');
    }
  };

  this.postSavedComment = function() {
    var savedComment = this.getSavedComment();
    if (!savedComment) return;
    this.removeSavedComment(true);
    setTimeout(function() {
      this.addMessage(savedComment).then(function(resp) {
        if (savedComment.parent_id) {
          $rootScope.$broadcast('comment:' + savedComment.parent_id + ':setChildComment', resp.data);
        }
      });
    }, 1000);
  };

  this.ECD = {};


  this.ECD.getECDTitle = function(commentId) {
    var ecd = service.ecd.find(ecd => {
      return ecd.comments.find(c => c.comment._id === commentId);
    });

    if (ecd) return ecd.title;
  };

  this.ECD.pushECD = function (title, comments) {
    var url = API_URL + '/thread/' + service.thread_id + '/ecd';
    var data = {
      title: title,
      comments: comments
    };
    return $http
      .post(url, data)
      .success(function (thread) {
        service.ecd = thread.ecd;
      })
      .error(api_error);
  };

  this.ECD.updateECD = function (id, newTitle, cb) {
    var url = API_URL + '/thread/' + service.thread_id + '/ecd/' + id;

    $http.put(url, {
      title: newTitle
    }).success(function (_data) {
      return cb(_data);
    }).error(api_error);
  };

  this.ECD.deleteECD = function (id, cb) {
    var url = API_URL + '/thread/' + service.thread_id + '/ecd/' + id;

    $http.delete(url)
      .success(function (_data) {
        return cb(_data);
      })
      .error(api_error);
  };

  this.ECD.selectAllTree = function (comment) {
    // Find parents and change their value
    function changeParents(comment, value, untilThisParent) {
      var cmt = service._comments[comment.parent_id];
      if (!cmt) {
        return;
      }

      cmt.editor_choice = value;

      if (untilThisParent && untilThisParent._id === cmt._id) {
        // Stop here because we said 'until this parent'
        return;
      }

      if (cmt.parent_id) {
        changeParents(cmt, value, untilThisParent);
      }
    }

    // Check if a comment is a descendant of another one
    function isParent(comment, parent) {
      var cmt = service._comments[comment.parent_id];
      if (cmt && cmt._id === parent._id) {
        return true;
      }
      if (cmt && cmt.parent_id) {
        return isParent(cmt, parent);
      }
      return false;
    }

    // The following algorithm is to make sure that the selected comments allaws follow each other

    var selected = JSON.parse(JSON.stringify(service.getSelectedECD()));

    if (selected.length === 0) {
      // No selection, change this one and it's parents
      comment.editor_choice = true;
      changeParents(comment, true);
    } else {
      if (comment.editor_choice === true) {
        // If this one is already selected
        comment.editor_choice = false;

        if (selected.length > 1) {
          // If there are already several selected
          if (comment._id !== selected[selected.length - 1]._id) {
            // It's not the last selected one, we unselect it and it's parents
            changeParents(comment, false);
          }
        }
      } else {
        // This one is not already selected
        comment.editor_choice = true;

        if (isParent(comment, selected[0])) {
          // If the first selected one is a parent
          // Change all parents until this first selected one
          changeParents(comment, true, selected[0]);
        } else {
          // The first selected is a child
          // Change all children until this first selected one
          changeParents(selected[0], true, comment);
        }
      }
    }
  };
}
]);
